"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethod = exports.Env = void 0;
var Env;

(function (Env) {
  Env["dummy"] = "dummy";
  Env["local"] = "local";
  Env["dev"] = "dev";
  Env["qa"] = "qa";
  Env["prod"] = "prod";
})(Env = exports.Env || (exports.Env = {}));

var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["notPresent"] = "notPresent";
  PaymentMethod["creditCard"] = "CC";
  PaymentMethod["ACH"] = "ACH";
  PaymentMethod["eCheck"] = "eCheck";
  PaymentMethod["ePaperToken"] = "ePaperToken";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Interfaces/interface.request.js